
import { defineComponent } from "vue";

export default defineComponent({
  name: "TextArea",
  data() {
    const text = this.modelValue;
    return { text, validation_message: undefined };
  },
  props: {
    modelValue: String,
    label: String,
    valid: Boolean,
    readonly: Boolean,
    maxlength: Number,
    not_editable: Boolean,
    manual_focus: Boolean,
    num_rows: Number,
  },
  emits: ["update:modelValue"],
  watch: {
    text(n) {
      this.$emit("update:modelValue", n);
    },
    modelValue(text: string) {
      this.text = text;
    },
  },
});
